import { type ReactNode } from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

import { strings } from '../../config/strings'

interface PDialogProps { 
    open: boolean, 
    onClose: ((event: {}, reason: "backdropClick" | "escapeKeyDown") => void),
    onSubmit?: React.MouseEventHandler<HTMLButtonElement>,
    loading?: boolean,
    title?: string, 
    body?: ReactNode,
    hideCancelButton?: boolean, 
    submitButtonLabel?: string,
    submitButtonColor?: "error" | "inherit" | "primary" | "secondary" | "success" | "info" | "warning"
}

export const PDialog = (props: PDialogProps) => {

    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth='xs' fullWidth disableRestoreFocus>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText variant='body2'>
                    {props.body}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {
                    !props.hideCancelButton && 
                    <Button fullWidth onClick={(event) => props.onClose(event, 'escapeKeyDown')}>
                        {strings.action_cancel}
                    </Button>
                }
                <Button 
                    fullWidth
                    variant='contained' 
                    loading={props.loading}
                    color={props.submitButtonColor} 
                    onClick={props.onSubmit}
                    >
                        {props.submitButtonLabel}
                </Button>
            </DialogActions>
        </Dialog>
    )
}